export default __webpack_public_path__ + "static/media/node-js-logo-only.9cbceb1d.png";